export class InvoiceRequestModel {
    ids: number[];
    month: number;
}

export const LAST_MONTH: number = 1;
export const MONTH_TO_DATE: number = 2;